<template>
  <div class="page-container page-multi-columns">

    <!-- Sidebar -->
    <div class="multi-sidebar">

      <div v-if="pgLoading" class="sidebar-top" style="width: 100%">
        <div class="webkit-animation webkit-100-200"></div>

        <div class="sidebar-link webkit-animation webkit-100-50 webkit-mt-1"></div>
        <div class="sidebar-link webkit-animation webkit-100-50 webkit-mt-1"></div>
        <div class="sidebar-link webkit-animation webkit-100-50 webkit-mt-1"></div>
        <div class="sidebar-link webkit-animation webkit-100-50 webkit-mt-1"></div>
        <div class="sidebar-link webkit-animation webkit-100-50 webkit-mt-1"></div>
      </div>


      <div v-if="!pgLoading" class="sidebar-top">
        <div class="big-logo-box mb-90">
          <router-link :to="{ name: 'home' }" class="big-logo">
            <img :src="logo.logo" alt="Logo"/>
          </router-link>
        </div>

        <div class="sidebar-link">
          <a href="javascript:void(0)" class="link active">Popular Searches</a>
        </div>
        <div class="sidebar-link" v-for="(nav, index) in popularSearch" :key="index">
          <router-link :to="{ name: 'show-popular-search', params:{slug: nav.slug}}" 
                class="link">{{ nav.title }}
          </router-link>
        </div>
        <div class="sidebar-link">
          <router-link :to="{ name: 'myCertificate' }" class="link">
            My Certificate
            <div>
              <small>You can view and print your certificate</small>
            </div>
          </router-link>
          <!-- <a href="https://www.agmep.group/VerifyAIPS.html" target="_blank" class="link">
            My Certificate
            <div>
              <small>You can view and print your certificate</small>
            </div>
          </a> -->
        </div>
      </div>

      <div v-if="!pgLoading" class="sidebar-bottom">
        <div class="footer-copyright">
          <div>American Institute of Professional Studies</div>
          <div>2021 All Rights Reserved © AIPS</div>
        </div>
      </div>

    </div>
    <!-- Sidebar -->


    <!-- Content -->
    <div class="multi-columns">
      <Navbar :containerFluidHome="true" :hiddenLogo="true" />

      <div v-if="pgLoading" class="content-multi webkit-animation"></div>
      <div v-if="!pgLoading" class="content-multi home-background"
        :style="{backgroundImage:`url(${home.image})`}">
          <div class="home-widget-explore">
            <div class="title">{{ home.title }}</div>
            <div class="description mb-4"> 
              <div v-html="home.body"></div>
              <router-link :to="{ name: 'about' }" class="read-more">
              {{ home.button }} <span class="icon-back"></span>
            </router-link>
          </div>
        </div>
      </div>
      <!-- Content -->

      <!-- Footer -->
      <Footer :containerFluidHome="true" />
      
      <!-- Footer -->
    </div>
    <!-- Content -->

  </div>
</template>

<style scoped>
  .home-background {
    background-size: cover;
  }
  .showDropdown {
    position: relative;
  }
  .showDropdown:after {
    content: "";
    position: absolute;
    top: 32px;
    left: 50%;
    transform: translateX(-50%);
    /* background: #000; */
    min-width: 120px;
    height: 16px;
    display: none;
  }
  .dropdown-container {
    position: absolute;
    background: #fff;
    padding: 5px 0;
    z-index: 20;
    min-width: 120px;
    left: 50%;
    transform: translateX(-50%);
    top: 46px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(3, 27, 78, 0.1);
    display: none;
  }
  .showDropdown:hover:after {
    display: block;
  }
  .showDropdown:hover .dropdown-container {
    display: block;
  }
  .dropdown-container a {
    display: block;
    text-align: left;
    padding: 7px 17px;
    line-height: 1;
  }
  .dropdown-container a:hover {
    background: #eee;
  }
  .home-widget-explore {
    padding: 40px;
    background-color: #fff;
    display: inline-block;
    position: relative;
    top: 140px;
    width: 360px;
  }

  .home-widget-explore .title {
    position: relative;
    margin-bottom: 27px;
    padding-bottom: 31px;
    font-size: 45px;
    font-weight: bold;
    color: #1b1464;
  }

  .home-widget-explore .title:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 150px;
    height: 7px;
    background-color: #c9dd5d;
  }

  .home-widget-explore .description {
    color: #6e6d76;
  }
  .nav-links {
    padding-left: 40px;
  }
  .page-multi-columns .nav .container-fluid {
    padding: 0;
  }
  .containerFluid {
    padding: 0;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .home-widget-explore .description span {
      font-size: 13.5px;
    }
  }

  @media (max-width: 767.98px) {
    .multi-sidebar {
      display: none;
    }
    .multi-columns {
      width: 100%;
    }
    .home-background {
      background-size: cover;
      background-position: top;
      height: 100%;
      width: calc(100% + 30px);
      margin: 0 -15px;
    }
    .home-widget-explore {
      width: 300px;
      left: 15px;
      padding: 23px 30px;
      max-width: calc(100% - 95px);
    }
    .home-widget-explore .title {
      font-size: 29px;
      margin-bottom: 10px;
      padding-bottom: 10px;
    }
    .home-widget-explore .title:after {
      height: 4px;
    }
    .home-widget-explore {
      position: absolute;
      top: auto;
      bottom: 85px;
    }
    .home-widget-explore .description p {
      font-size: 13px;
    }
    .content-multi {
      min-height: auto;
      height: calc(100% - 40px) !important;
    }
    .home-widget-explore .description {
      font-size: 14px;
    }
    .page-multi-columns {
      background: #1b1464;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .home-widget-explore {
      top: 40px;
    }
    .home-widget-explore .title {
      margin-bottom: 13px;
      padding-bottom: 13px;
      font-size: 27px;
    }
  }

  @media (min-width: 768px) and (max-width: 1199.98px) {
    .multi-sidebar {
      display: none;
    }
    .multi-columns {
      width: 100%;
    }
    .content-multi {
      height: calc(100% - 127px) !important;
    }
    .home-widget-explore {
      padding: 30px;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }

  .read-more:hover {
    color: #fff !important;
  }
</style>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";

export default {
  name: "Home",
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      pgLoading: true,
      home: '',
      logo: '',
      popularSearch: [],
    };
  },
  watch: {
    $route() {
      this.fetchHome();
    },
  },
  created() {
    // Check Auth
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    this.fetchHome();
  },
  methods: {
   

    fetchHome() {
      axios
        .get(window.baseURL + "/home")
        .then((res) => {
          this.pgLoading = false;
          this.logo = res.data.logo;
          this.home = res.data.home;
          this.popularSearch = res.data.searchs;
        })
        .catch(() => {});
    },

  },
};
</script>
